import React, { lazy, Suspense } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import history from '../history'


import {
  WELCOME_SCREEN,
  LOGIN_SCREEN,
  MAIN_SCREEN,
  SELECT_PLAN_SCREEN,
  ABOUT_YOU,
  VIDEO,
  TRENNING_PLAN,
  PROGRESS,
  PROGRESS_ENTRY,
  COMPARE_ENTRY,
  MOBILE_FOLDER,
  LIVE_SCREEN,
  CACLCULATOR,
  SPLASH_SCREEN,
  ACCEPT_PAYMENT,
  CANCEL_PAYMENT,
  DIET_MAIN_SCREEN,
  FILTER_MEALS_SCREEN,
  MEAL_DETAILS_SCREEN,
  MEALS_SCREEN,
  SHOPPING_LIST_SCREEN,
  CHOOSE_DIET_SCREEN,
  USER_PROFILE,
  CHATBOX,
  ALBUM,
  CONFERENCES_SCREEN,
  CONFERENCES_SINGLE_ROOM,
  LANDING_PAGE,
  CHOOSE_MIAZGA_VERSION,
CHALLENGES_MAIN_PAGE,
CHALLENGES_ALBUM_PAGE,
CHALLENGE_PURCHASE
} from './routeURL/index'

import LoginScreen from '../components/LoginScreen/Red_LoginScreen'
import MainScreen from '../components/MainScreen/MainScreenContainer.js'
import SelectSubscriptionPlanScreen from '../components/SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreenContainer'
import AddUserScreen from '../components/AddUserScreen/AddUserContainer'
import NotFound from '../components/404/NotFound'
import VideoScreen from '../components/VideoScreen/VideoScreenContainer'
import PlanScreen from '../components/PlanScreen/PlanScreenContainer'
import EntryScreen from '../components/EntryScreen/EntryScreenContainer'
import CompareScreen from '../components/CompareScreen/CompareScreenContainer'
import MobileFolderScreen from '../components/MobileFolderScreen/MobileFolderScreenContainer'
import LiveScreen from '../components/LiveScreen/Live'
import CalculatorScreen from '../components/CalculatorScreen/CalculatorContainer.tsx'
import WaterReminderScreen from '../components/WaterReminderScreen/WaterReminderContainer.tsx'
import WelcomeScreen from '../components/WelcomeScreen/WelcomeScreenContainer'
import SplashScreen from '../components/SplashScreen/SplashScreen'
import AcceptPayment from '../components/AcceptPayment/AcceptPayment.jsx'
import CancelPayment from '../components/CancelledPayment/CancelledPayment.jsx'
import DietMainScreen from '../components/DietModule/DietMainScreen/DietMainScreenContainer'
import ChooseDietScreenContainer from '../components/DietModule/ChooseDietScreen/ChooseDietScreenContainer'
import FilterMealsScreen from '../components/DietModule/FilterMealsScreen/FilterMealsScreenContainer'
import MealDetailsScreen from '../components/DietModule/MealDetailsScreen/MealDetailsScreenContainer'
import MealsScreen from '../components/DietModule/MealsScreen/MealsScreenContainer'
import ShoppingListScreen from '../components/DietModule/ShoppingListScreen/ShoppingListScreenContainer'
import NewProgressScreen from '../components/Red_ProgressScreen/ProgressScreen.tsx'
import UserProfileScreen from '../components/UserProfileScreen/UserProfile.tsx'
import ChatBox from '../components/ChatBox/Chatbox.tsx'
import AlbumScreen from '../components/AlbumScreen/AlbumScreen.tsx'
import ConferencesScreen from '../components/ConferencesScreen/ConferencesScreen.tsx'
import ConferencesSingleRoom from '../components/ConferencesScreen/ConferencesSingleRoom.tsx'
import AppleAssoc from '../components/appleAssoc'
import LandingPage from '../components/LandingPage/LandingPage.tsx'
import ChooseMiazgaVersion from '../components/Challenges/views/ChooseMiazgaVersion'
import ChallengesMainScreen from '../components/Challenges/views/ChallengesMainScreen'
import ChallengesAlbumScreen from '../components/Challenges/views/ChallengesAlbumScreen'
import ChallengePurchase from '../components/Challenges/views/ChallengePurchase'

import AppleAssocJson from '../appleAssoc.json'

const reload = () => window.location.reload()
const AppRouter = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path="/.well-known/apple-app-site-association"
          component={AppleAssoc}
        ></Route>
        <Route exact path={CHALLENGE_PURCHASE} component={ChallengePurchase} />
        <Route exact path={SPLASH_SCREEN} component={SplashScreen} />
        <Route exact path={CHOOSE_MIAZGA_VERSION}  component={ChooseMiazgaVersion}/>
        <Route exact path={CHALLENGES_MAIN_PAGE}  component={ChallengesMainScreen}/>
        <Route exact path={CHALLENGES_ALBUM_PAGE}  component={ChallengesAlbumScreen}/>
        <Route exact path={LANDING_PAGE} component={LandingPage} />
        <Route exact path={MAIN_SCREEN} component={MainScreen} />
        <Route exact path={WELCOME_SCREEN} component={WelcomeScreen} />
        <Route exact path={LOGIN_SCREEN} component={LoginScreen} />
        <Route exatc path={ABOUT_YOU} component={AddUserScreen} />
        <Route exact path={VIDEO} component={VideoScreen} />
        <Route exact path={TRENNING_PLAN} component={PlanScreen} />
        <Route exact path={PROGRESS} component={NewProgressScreen} />
        <Route exact path={PROGRESS_ENTRY} component={EntryScreen} />
        <Route exact path={COMPARE_ENTRY} component={CompareScreen} />
        <Route exact path={MOBILE_FOLDER} component={MobileFolderScreen} />
        <Route exact path={LIVE_SCREEN} component={LiveScreen} />
        <Route exact path={CACLCULATOR} component={CalculatorScreen} />
        {/* <Route exact path="/picie-wody" component={WaterReminderScreen} /> */}
        <Route
          exact
          path={SHOPPING_LIST_SCREEN}
          component={ShoppingListScreen}
        />
        <Route exact path={FILTER_MEALS_SCREEN} component={FilterMealsScreen} />
        <Route
          exact
          path={CHOOSE_DIET_SCREEN}
          component={ChooseDietScreenContainer}
        />
        <Route exact path={MEAL_DETAILS_SCREEN} component={MealDetailsScreen} />
        <Route exact path={MEALS_SCREEN} component={MealsScreen} />
        <Route exact path={DIET_MAIN_SCREEN} component={DietMainScreen} />
        <Route
          exact
          path={SELECT_PLAN_SCREEN}
          component={SelectSubscriptionPlanScreen}
        />
        <Route exact path={ACCEPT_PAYMENT} component={AcceptPayment} />
        <Route exact path={CANCEL_PAYMENT} component={CancelPayment} />
        <Route exatc path={USER_PROFILE} component={UserProfileScreen} />
        <Route exact path={CHATBOX} component={ChatBox} />
        <Route exact path={ALBUM} component={AlbumScreen} />
        <Route exact path={CONFERENCES_SCREEN} component={ConferencesScreen} />
        <Route
          exact
          path={CONFERENCES_SINGLE_ROOM}
          component={ConferencesSingleRoom}
        />
        <Route component={NotFound} />
      </Switch>
    </Router>
  )
}

export default AppRouter
